import React from 'react';

export default function Footer() {
  return (
    <footer className=" text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
       
      </div>
    </footer>
  );
}

